import { render, staticRenderFns } from "./top-info.vue?vue&type=template&id=2dbb94c8&scoped=true"
import script from "./top-info.vue?vue&type=script&lang=js"
export * from "./top-info.vue?vue&type=script&lang=js"
import style0 from "./top-info.vue?vue&type=style&index=0&id=2dbb94c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb94c8",
  null
  
)

export default component.exports